<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="kanban">
                <div class="card-header pb-0">
                    <div class="justify-content-between d-flex">
                        <div class="d-grid gap-2 d-flex">
                            <button 
                                type="button"
                                @click="download"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                <i class="fa fa-download" v-if="!loading"></i> Download Form PDF
                            </button>
                            <button 
                                type="button"
                                @click="downloadXlsx"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_xlsx ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_xlsx"></span>
                                <i class="fa fa-download" v-if="!loading_xlsx"></i> Download Form XLSX
                            </button>
                            <button 
                                type="button"
                                @click="downloadKanban"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_kanban ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_kanban"></span>
                                <i class="fa fa-download" v-if="!loading_kanban"></i> Download Kanban
                            </button>
                        </div>
                        <argon-badge variant="gradient" color="primary" class="text-xxs align-self-center" v-if="kanban.state">{{ kanban.state }}</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-80 pt-0">
                    <h5>#{{ kanban.name }}</h5>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Vendor</td>
                                        <td class="font-weight-bold">{{ kanban.partner_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Vendor Code</td>
                                        <td class="font-weight-bold">{{ kanban.partner_code }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Delivery Date</td>
                                        <td class="font-weight-bold">{{ kanban.delivery_date }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary" width="30%">Delivery Time</td>
                                        <td class="font-weight-bold">{{ kanban.delivery_time }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary">Expected Date</td>
                                        <td class="font-weight-bold">{{ kanban.expected_date }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Cycle</td>
                                        <td class="font-weight-bold">{{ kanban.cycle_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Transporter</td>
                                        <td class="font-weight-bold">{{ kanban.transporter }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Plant Site</td>
                                        <td class="font-weight-bold">{{ kanban.plant_site }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary" width="30%">Dock Parking</td>
                                        <td class="font-weight-bold">{{ kanban.dock_parking }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary">Total Kanban</td>
                                        <td class="font-weight-bold">{{ kanban.total_kanban }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Shop</td>
                                        <td class="font-weight-bold">{{ kanban.shop }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Purchase Number</td>
                                        <td class="font-weight-bold">{{ kanban.purchase_number }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary" width="30%">Projects</td>
                                        <td class="font-weight-bold">
                                            <argon-badge style="margin-left: 2px;" v-for="project,i in kanban.project_name" :key="i" 
                                                color="secondary"
                                                size="sm">{{ project }}
                                            </argon-badge>
                                        </td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary" width="30%">Customer ID</td>
                                        <td class="font-weight-bold">
                                            <argon-badge style="margin-left: 2px;" v-for="customer,i in kanban.customer_ids" :key="i" 
                                                color="secondary"
                                                size="sm">{{ customer }}
                                            </argon-badge>
                                        </td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary">Already Invoiced</td>
                                        <td class="font-weight-bold"><input type="checkbox" disabled :checked="kanban.is_invoiced === true"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr class="bg-light">
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">#</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Part Code</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Part Name</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">UoM</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Purchase Order</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Projects</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Qty Kanban</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Total Kanban</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Total Qty</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Qty Received</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in kanban.line_ids" :key="line.id">
                                    <td class="text-xs mb-0 ps-2">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.product_code }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.product_name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.uom }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.purchase_id }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.project_id }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.qty_kanban }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0 px-2">{{ line.total_kanban }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0 px-2">{{ line.total_qty }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0 px-2">{{ line.qty_received }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require("../router/endpoint");

export default {
  name: "kanban-detail",
  data() {
    return {
      kanban: null,
      loading: false,
      loading_kanban: false,
      loading_xlsx: false,
    };
  },
  components: {
    ArgonBadge
  },
  methods: {
    getKanbanDetail() {
      this.axios
        .post(
          endpoint.DN_DETAIL,
          {
            id: this.$route.params.id,
            partner_id: localStorage.getItem("partner_id")
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.response_code === "0000") {
            this.kanban = response.data.data;
          } else {
            this.$notify({
              type: "warn",
              title: "Warning",
              text: response.data.message
            });
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Failed",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    download () {
        this.loading = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.action_report_delivery_notes'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.kanban.name + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading = false
            })
            .catch((e) => {
            this.loading = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        },
    downloadXlsx () {
        this.loading_xlsx = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.delivery_notes_xlsx'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.kanban.name + ".xlsx";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading_xlsx = false
            })
            .catch((e) => {
            this.loading_xlsx = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        },
    downloadKanban () {
        this.loading_kanban = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.action_report_kanban_vendor'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.kanban.name + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading_kanban = false
            })
            .catch((e) => {
            this.loading_kanban = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        }
  },
  mounted() {
    this.getKanbanDetail();
  }
};
</script>

<style>

</style>